
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import NibyorWebsite from "./NibyorWebsite";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <NibyorWebsite />
  </React.StrictMode>
);
